import { DataTable } from "src/models/dataTable";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DataTableEntityModel = createEntityModel<DataTable>();
